import { CommonModule } from '@angular/common';
import { Component, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { RouterOutlet, RouterLink, RouterLinkActive, ActivatedRoute, Router } from '@angular/router';

export interface NavLink {
  route: string;
  label: string;
  icon: string;
  /** Kleine Zahl neben dem Label, z. B. offene Punkte; ausgeblendet bei 0 oder ohne Wert. */
  badge?: number;
  /** Tooltip und Screenreader-Text der Zahl. */
  badgeLabel?: string;
}

@Component({
    selector: 'app-tab-navigation',
    imports: [CommonModule, MatIconModule, MatTabsModule, RouterOutlet, RouterLink, RouterLinkActive],
    templateUrl: './tab-navigation.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './tab-navigation.component.scss'
})
export class TabNavigationComponent {
  router = inject(Router);
  route = inject(ActivatedRoute);

  tabRoutes = input.required<NavLink[]>();
  justifyContent = input<'left' | 'center' | 'right'>('center');
}
